// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_REVIEW_REPLY = "Pridaj odpove\u010f";
export const CANCEL = "Zru\u0161";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const YOUR_REPLY = "Tvoja odpove\u010f";
